import React from 'react';
import {useParams} from 'react-router-dom';
import {Title, TitleLevel, TitleSize, TitleColor} from 'components/ui/Title';
import SupplementTile from '../SupplementTile';
import {TARIFF_SUGGESTIONS} from 'data/tariffSuggestions';
import Container from 'components/layout/Container';

import './Suggestions.scss';

const Suggestions = () => {
  const {slug} = useParams();
  const suggestions = TARIFF_SUGGESTIONS[slug];

  if (!suggestions?.length) {
    return null;
  }

  return (
    <section className="suggestions">
      <Container>
        <Title
          extraClassName="suggestions__title"
          level={TitleLevel.H4}
          size={TitleSize.H3}
          color={TitleColor.black}
        >
          Что можно добавить
        </Title>

        <div className="suggestions__list">
          {suggestions.map((suggestion, index) => (
            <SupplementTile
              supplement={suggestion}
              key={index}
            ></SupplementTile>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Suggestions;
